module.exports = __webpack_public_path__ + "img/press-04.8ddbc22d.jpeg";